import { createSlice } from "@reduxjs/toolkit";
import { sortByKey } from "../components/Utilities/CommonFunc";
import toolbarConfiguration from "../components/Toolbar/toolbarConfig";

const {
  category,
  sku,
  DC,
  supplier,
  risk_type,
  tier2_suppliers,
  tier2_skus,
  supplier_org,
  assembly_item,
} = toolbarConfiguration.filterMap;

const wfSummarySlice = createSlice({
  name: "wfSummary",
  initialState: {
    apiLoading: {
      header: false,
      date: false,
      gaugeCharts: false,
      supplierAlerts: false,
      productAlerts: false,
      closingRisksTrend: false,
      businessRunOut: false,
    },
    hdrData: [],
    prevHdrData: [],
    iconData: [],
    prevIconData: [],
    pieChartData: [],
    filteredPieChartData: [],
    locationAlertsData: [],
    prevLocationAlertsData: [],
    productAlertsData: [],
    prevProductAlertsData: [],
    countsData: {},
    filters: {
      [category.filterId]: [],
      [sku.filterId]: [],
      [supplier.filterId]: [],
      [DC.filterId]: [],
      [tier2_suppliers.filterId]: [],
      [tier2_skus.filterId]: [],
      [risk_type.filterId]: [],
      [supplier_org.filterId]: [],
      [assembly_item.filterId]: [],
      country: [],
    },
    riskTrendData: [],
    prevRiskTrendData: [],
    businessRunOutData: [],
    prevBusinessRunOutData: [],
    resetTriggered: false,
  },
  reducers: {
    setLoader(state, action) {
      state.apiLoading[action.payload.loaderKey] = action.payload.loaderValue;
    },
    setHdrData(state, action) {
      state.hdrData = action.payload;
    },
    setCountsData(state, action) {
      state.countsData = action.payload;
    },
    setFilters(state, action) {
      const { filters, filterId } = action.payload;
      const currentFilters = state.filters;

      if (filterId && filterId !== "status") {
        delete filters[filterId];
      }

      state.filters = {
        ...currentFilters,
        ...filters,
      };
    },
    setPrevHdrData(state, action) {
      state.prevHdrData = action.payload;
    },
    setIconData(state, action) {
      state.iconData = action.payload;
    },
    setPrevIconData(state, action) {
      state.prevIconData = action.payload;
    },
    setLocationAlertsData(state, action) {
      const data = action.payload;
      const sorted = sortByKey(data, "number");
      state.locationAlertsData = sorted;
    },
    setPrevLocationAlertsData(state, action) {
      const data = action.payload;
      const sorted = sortByKey(data, "number");
      state.prevLocationAlertsData = sorted;
    },
    setProductAlertsData(state, action) {
      const data = action.payload;
      const sorted = sortByKey(data, "number");
      state.productAlertsData = sorted;
    },
    setPrevProductAlertsData(state, action) {
      const data = action.payload;
      const sorted = sortByKey(data, "number");
      state.prevProductAlertsData = sorted;
    },
    setPieChartData(state, action) {
      state.pieChartData = action.payload;
    },
    setFilteredPieChartData(state, action) {
      state.filteredPieChartData = action.payload;
    },
    setResetTriggered(state, action) {
      state.resetTriggered = action.payload;
    },
    setRiskTrendData(state, action) {
      state.riskTrendData = action.payload;
    },
    setPrevRiskTrendData(state, action) {
      state.prevRiskTrendData = action.payload;
    },
    setBusinessRunOutData(state, action) {
      state.businessRunOutData = action.payload;
    },
    setPrevBusinessRunOutData(state, action) {
      state.prevBusinessRunOutData = action.payload;
    },
  },
});

export const {
  setLoader,
  setHdrData,
  setPrevHdrData,
  setIconData,
  setPrevIconData,
  setPieChartData,
  setFilteredPieChartData,
  setResetTriggered,
  setLocationAlertsData,
  setPrevLocationAlertsData,
  setProductAlertsData,
  setPrevProductAlertsData,
  setFilters,
  setCountsData,
  setRiskTrendData,
  setPrevRiskTrendData,
  setBusinessRunOutData,
  setPrevBusinessRunOutData,
} = wfSummarySlice.actions;

export default wfSummarySlice.reducer;
